import { makeStyles } from '@material-ui/core/styles';

const useOperationalControlKanbanStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
    backgroundColor: '#ffffff',
  },

  scrollContainer: {
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  },

  contentMinWidth: {
    flex: 1,
    minHeight: 0,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
  },

  stickyFilters: {
    flex: '0 0 auto',
    margin: '8px 4px 4px',
    background: '#E6E7E8',
  },

  accordion: {
    flex: '0 0 auto',
    marginBottom: 8,
  },

  kanbanScroll: {
    flex: '1 ',
    minHeight: 0,
    overflowX: 'auto',
    overflowY: 'auto',
    position: 'relative',
    paddingBottom: 8,
  },
  modalContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default useOperationalControlKanbanStyles;
